import axios from "axios";
import { base_url } from "../config";

export const createTable = async (tableData) => {
  const accessToken = localStorage.getItem("@user");

  try {
    const response = await axios.post(`${base_url}/tables/create`,
      tableData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error creating table:",
      error.response?.data || error.message
    );
    throw error;
  }
};
